import { Users, Target, Shield } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen py-16" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Sobre o Bitcoin Atlas
        </h1>
        <p className="text-lg text-muted-foreground mb-12">
          Navegando o mundo do Bitcoin com educação e soberania
        </p>

        <div className="prose prose-lg max-w-none mb-16">
          <p className="text-lg leading-relaxed mb-6">
            O Bitcoin Atlas nasceu da necessidade de criar um espaço educacional dedicado exclusivamente ao Bitcoin,
            focando em autocustódia, privacidade e soberania financeira.
          </p>
          <p className="text-lg leading-relaxed mb-6">
            Em um mundo onde a informação sobre Bitcoin frequentemente é misturada com especulação sobre
            outras criptomoedas, decidimos criar um projeto que se concentra apenas no que realmente importa:
            educar pessoas sobre dinheiro sólido, descentralizado e resistente à censura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="bg-card border border-border rounded-sm p-6">
            <Target className="text-primary mb-4" size={40} />
            <h3 className="text-xl font-bold mb-3">Nossa Missão</h3>
            <p className="text-muted-foreground">
              Educar o público brasileiro sobre Bitcoin, promovendo autocustódia e soberania financeira.
            </p>
          </div>

          <div className="bg-card border border-border rounded-sm p-6">
            <Shield className="text-primary mb-4" size={40} />
            <h3 className="text-xl font-bold mb-3">Nossos Valores</h3>
            <p className="text-muted-foreground">
              Independência, transparência, educação gratuita e foco exclusivo em Bitcoin.
            </p>
          </div>

          <div className="bg-card border border-border rounded-sm p-6">
            <Users className="text-primary mb-4" size={40} />
            <h3 className="text-xl font-bold mb-3">Nossa Comunidade</h3>
            <p className="text-muted-foreground">
              Mais de 10.000 leitores mensais aprendendo sobre Bitcoin de forma responsável.
            </p>
          </div>
        </div>

        <div className="bg-card border border-border rounded-sm p-8 mb-12">
          <h2 className="text-2xl font-bold mb-4">O que nos diferencia</h2>
          <ul className="space-y-3 text-muted-foreground">
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1 font-bold">•</span>
              <span><strong>Bitcoin Only:</strong> Não promovemos outras criptomoedas ou projetos duvidosos</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1 font-bold">•</span>
              <span><strong>Autocustódia:</strong> Ensinamos as pessoas a terem controle total sobre seus Bitcoin</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1 font-bold">•</span>
              <span><strong>Privacidade:</strong> Respeitamos e ensinamos sobre privacidade financeira</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1 font-bold">•</span>
              <span><strong>Independência:</strong> Não somos financiados por exchanges ou empresas do setor</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1 font-bold">•</span>
              <span><strong>Conteúdo em Português:</strong> Material de qualidade no idioma nativo brasileiro</span>
            </li>
          </ul>
        </div>

        <div className="bg-primary/10 border-2 border-primary rounded-sm p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Faça parte da nossa missão</h3>
          <p className="text-muted-foreground mb-6">
            Se você acredita na importância da educação sobre Bitcoin e soberania financeira,
            considere apoiar nosso projeto.
          </p>
          <a href="/doar" className="inline-block">
            <button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm px-6 py-3 font-bold uppercase tracking-wide shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none">
              Apoiar o Projeto
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;